import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const BackSection = styled.div`
    padding: 8px 13px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const BackText = styled.span`
    font-size: 12px;
    line-height: 16px;
    color: #2b3b67;
    margin-left: 3px;
    vertical-align: middle;
`;

export const BottomSection = styled.div`
    background: ${colorsPalettes.bluegrey[100]};
    padding: 10px 22px 14px;
    display: flex;
    justify-content: flex-end;
`;

export const GranularitySwitchContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
`;

export const BackSectionGranularitySwitch = styled(BackSection)`
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px 13px 4px;
    border-bottom: none;
`;
